<template>
  <div class="container home page">
    <div class="row">
      <div class="body-pane col-lg-8">
        <div class="content">
          <hgroup>
            <h2><strong>STATUS:</strong> Currently Searching for Work</h2>
            <p>Updated: August 29, 2026</p>
          </hgroup>
          <p>My last project ended 8/28/26 with HealthEdge.</p>
          <p>I was debugging and enhancing a proprietary React project, primarily focused on accessibility concessions. I was also updating unit tests and running the site through the NVDA screen reader.</p>
          <p>Now I am looking for another role.</p>
        </div>
      </div>
      <div class="aux col-lg-4">
        <div class="ad">
          <h3>NOW AVAILABLE EVERYWHERE MUSIC IS STREAMED</h3>
          <img src="../assets/Rhystron-CD-2.webp" width="100%" alt="Rhystron album cover: There'll Be No Mercy" />
        </div>

        <div class="ad">
          <h3>PREVIOUS RELEASE</h3>
          <img src="../assets/Rhystron-CD-UiB.webp" width="100%" alt="Rhystron album cover: Ugly in Blue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
}
</script>
